export const DEFAULT_SETTINGS_ACTIONS = {
  ONBOARDING: 'onboarding',
  OFFBOARDING: 'offboarding',
}

export const DEFAULT_SETTINGS_ACTION_TO_MESSAGE = {
  [DEFAULT_SETTINGS_ACTIONS.ONBOARDING]: 'ENGAGE.ONBOARD.ONBOARDING',
  [DEFAULT_SETTINGS_ACTIONS.OFFBOARDING]: 'ENGAGE.OFFBOARD.OFFBOARDING',
}
